@if (selectedHelpModule) {
  <div style="display: flex; flex-direction: column; gap: 10px;margin-top: 8px;">
    <!-- Device Help -->
    @if (selectedHelpModule === 'Device') {
      <sh-text id="help-modal-text-1" size="title-1">{{ 'helpModal.deviceHelp.title' | transloco }}</sh-text>
    }
    @if (selectedHelpModule === 'Device') {
      <sh-text id="help-modal-text-2">
        {{ 'helpModal.deviceHelp.text1' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Device') {
      <sh-text id="help-modal-text-3">
        {{ 'helpModal.deviceHelp.text2' | transloco }}
      </sh-text>
    }
    <!-- Header for Widget Overviews -->
    @if (selectedHelpModule === 'System Health' || selectedHelpModule === 'Service Metrics' || selectedHelpModule === 'Service History' || selectedHelpModule === 'Functional Location Overview' || selectedHelpModule === 'Upcoming-Services-Gen') {
      <sh-text id="help-modal-text-4" size="title-1"
      >{{ translatedSelectedHelpModule }}</sh-text>
    }
    @if (selectedHelpModule === 'System Health') {
      <sh-text id="help-modal-text-5">
        {{ 'helpModal.systemHealth.description1' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'System Health') {
      <sh-text id="help-modal-text-6">
        {{ 'helpModal.systemHealth.description2' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Service Metrics') {
      <sh-text id="help-modal-text-7">
        {{ 'helpModal.serviceMetrics.description' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Service History') {
      <sh-text id="help-modal-text-8">
        {{ 'helpModal.serviceHistory.description1' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Service History') {
      <sh-text id="help-modal-text-9">
        {{ 'helpModal.serviceHistory.description2' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Functional Location Overview') {
      <sh-text id="help-modal-text-10">
        {{ 'helpModal.funclocOverview.description' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Upcoming-Services-Gen') {
      <sh-text id="help-modal-text-11">
        {{ 'helpModal.upcomingServices.description' | transloco }}
      </sh-text>
    }
    @if (selectedHelpModule === 'CDI') {
      <sh-text id="help-modal-text-12" size="title-1"> {{ 'helpModal.cdi.title' | transloco }} </sh-text>
    }
    @if (selectedHelpModule === 'CDI') {
      <sh-text id="help-modal-text-13">{{ 'helpModal.cdi.description' | transloco }}</sh-text>
    }
    @if (selectedHelpModule === 'CI') {
      <sh-text id="help-modal-text-14" size="title-1"> {{ 'helpModal.ci.title' | transloco }} </sh-text>
    }
    @if (selectedHelpModule === 'CI') {
      <sh-text id="help-modal-text-15">{{ 'helpModal.ci.description' | transloco }}</sh-text>
    }
    @if (selectedHelpModule === 'CDI' || selectedHelpModule === 'CI') {
      <sh-divider id="help-modal-divider-16"></sh-divider>
    }
    <!-- Traffic Light Explanation -->
    @if (selectedHelpModule !== 'System Health' && selectedHelpModule !== 'Service Metrics' && selectedHelpModule !== 'Service History' && selectedHelpModule !== 'Functional Location Overview' && selectedHelpModule !== 'Upcoming-Services-Gen' && selectedHelpModule !== 'Device' && selectedHelpModule !== 'feedback'  && selectedHelpModule !== 'versions' && selectedHelpModule !== 'Upcoming-Services-soon' && selectedHelpModule !== 'Anomaly Detection') {
      <sh-text id="help-modal-text-17" size="title-1"
        >
        {{ 'helpModal.trafficLight.question' | transloco:{ module: translatedSelectedHelpModule } }}
      </sh-text>
    }
    @if (selectedHelpModule === 'Autocheck') {
      <sh-text id="help-modal-text-18"></sh-text>
    }
    @if (selectedHelpModule === 'Autocheck') {
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-20">{{ 'helpModal.autocheck.success' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-22">{{ 'helpModal.autocheck.warning' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
          <sh-text id="help-modal-text-24">{{ 'helpModal.autocheck.error' | transloco }}</sh-text>
        </div>
      </div>
    }
    @if (selectedHelpModule === 'Maintenance') {
      <sh-text id="help-modal-text-25"></sh-text>
    }
    @if (selectedHelpModule === 'Maintenance') {
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-27">{{ 'helpModal.maintenance.success' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-29">{{ 'helpModal.maintenance.warning' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
          <sh-text id="help-modal-text-31">{{ 'helpModal.maintenance.error' | transloco }}</sh-text>
        </div>
      </div>
    }
    @if (selectedHelpModule === 'Proactive Alarms') {
      <sh-text id="help-modal-text-32"></sh-text>
    }
    @if (selectedHelpModule === 'Proactive Alarms') {
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-34">{{ 'helpModal.proactiveAlarms.success' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-36">{{ 'helpModal.proactiveAlarms.warning' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
          <sh-text id="help-modal-text-38">{{ 'helpModal.proactiveAlarms.error' | transloco }}</sh-text>
        </div>
      </div>
    }
    @if (selectedHelpModule === 'QC') {
      <sh-text id="help-modal-text-39"></sh-text>
    }
    @if (selectedHelpModule === 'QC') {
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-41">{{ 'helpModal.qc.success' | transloco }}</sh-text>
        </div>
        <div style="display:flex; align-items: center; gap: 8px;">
          <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-icon-color)" size="xs"></sh-icon>
          <sh-text id="help-modal-text-43">{{ 'helpModal.qc.warning' | transloco }}</sh-text>
        </div>
        <!-- <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-45">Assay Troubleshooting only available for Atellica Solution and CI 1900  </sh-text>
      </div> -->
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-47">{{ 'helpModal.qc.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Events') {
    <sh-text id="help-modal-text-48"></sh-text>
  }
  @if (selectedHelpModule === 'Events') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-50">{{ 'helpModal.events.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-52">{{ 'helpModal.events.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-54">{{ 'helpModal.events.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Notifications') {
    <sh-text id="help-modal-text-55"></sh-text>
  }
  @if (selectedHelpModule === 'Notifications') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-57">{{ 'helpModal.notifications.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-59">{{ 'helpModal.notifications.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-61">{{ 'helpModal.notifications.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Spare Parts Used') {
    <sh-text id="help-modal-text-62"></sh-text>
  }
  @if (selectedHelpModule === 'Spare Parts Used') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-64">{{ 'helpModal.spareParts.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-66">{{ 'helpModal.spareParts.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-68">{{ 'helpModal.spareParts.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Site Visits') {
    <sh-text id="help-modal-text-69"></sh-text>
  }
  @if (selectedHelpModule === 'Site Visits') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-71">{{ 'helpModal.siteVisits.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-73">{{ 'helpModal.siteVisits.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-75">{{ 'helpModal.siteVisits.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Escalations') {
    <sh-text id="help-modal-text-76"></sh-text>
  }
  @if (selectedHelpModule === 'Escalations') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-78">{{ 'helpModal.escalations.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-80">{{ 'helpModal.escalations.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-82">{{ 'helpModal.escalations.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'CDI') {
    <sh-text id="help-modal-text-83"></sh-text>
  }
  @if (selectedHelpModule === 'CDI') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-85">{{ 'helpModal.cdiTrafficLight.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-87">{{ 'helpModal.cdiTrafficLight.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-89">{{ 'helpModal.cdiTrafficLight.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'CI') {
    <sh-text id="help-modal-text-90"></sh-text>
  }
  @if (selectedHelpModule === 'CI') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-92">{{ 'helpModal.ciTrafficLight.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-94">{{ 'helpModal.ciTrafficLight.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-96">{{ 'helpModal.ciTrafficLight.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Functional Location') {
    <sh-text id="help-modal-text-97"></sh-text>
  }
  @if (selectedHelpModule === 'Functional Location') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-99">{{ functionalLocationSuccessText }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-101">{{ functionalLocationWarningText }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-103">{{ functionalLocationErrorText }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Upcoming-Services') {
    <sh-text id="help-modal-text-104"></sh-text>
  }
  @if (selectedHelpModule === 'Upcoming-Services') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-success" icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-106">{{ 'helpModal.upcomingServicesTrafficLight.success' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-warning" icon="warning" color="var(--warning-yellow)" size="xs"></sh-icon>
        <sh-text id="help-modal-text-108">{{ 'helpModal.upcomingServicesTrafficLight.warning' | transloco }}</sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon id="help-modal-icon-error" icon="error" size="xs"></sh-icon>
        <sh-text id="help-modal-text-110">{{ 'helpModal.upcomingServicesTrafficLight.error' | transloco }}</sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Upcoming-Services-soon') {
    <sh-text id="help-modal-text-111"></sh-text>
  }
  @if (selectedHelpModule === 'Upcoming-Services-soon') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      {{ 'helpModal.upcomingServicesSoon' | transloco }}
    </div>
  }
  <!-- Anomaly Detection -->
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text size="title-1">{{ 'helpModal.anomalyDetection.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      {{ 'helpModal.anomalyDetection.intro' | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text size="title-2">{{ 'helpModal.anomalyDetection.whyNotCount.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      {{ 'helpModal.anomalyDetection.whyNotCount.text' | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text size="title-2">{{ 'helpModal.anomalyDetection.rateCalculated.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      {{ 'helpModal.anomalyDetection.rateCalculated.text' | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text size="title-2">{{ 'helpModal.anomalyDetection.outliers.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      {{ 'helpModal.anomalyDetection.outliers.text' | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text size="title-2">{{ 'helpModal.anomalyDetection.examples.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <div style="display: flex; flex-direction: column; gap: 8px;">
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text><b>{{ 'helpModal.anomalyDetection.example1' | transloco }}</b></sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon icon="error" size="xs"></sh-icon>
        <sh-text><b>{{ 'helpModal.anomalyDetection.example2' | transloco }}</b></sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon icon="error" size="xs"></sh-icon>
        <sh-text><b>{{ 'helpModal.anomalyDetection.example3' | transloco }}</b></sh-text>
      </div>
      <div style="display:flex; align-items: center; gap: 8px;">
        <sh-icon icon="success" color="var(--success-icon-color)" size="xs"></sh-icon>
        <sh-text><b>{{ 'helpModal.anomalyDetection.example4' | transloco }}</b></sh-text>
      </div>
    </div>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-divider></sh-divider>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      <b>{{ 'helpModal.anomalyDetection.keyTakeaway' | transloco }}</b>
    </sh-text>
  }
  @if (selectedHelpModule === 'Anomaly Detection') {
    <sh-text>
      <b>{{ 'helpModal.anomalyDetection.note' | transloco }}</b>
    </sh-text>
  }
  <!-- Feedback -->
  @if (selectedHelpModule === 'feedback') {
    <sh-text id="help-modal-text-112" size="title-1">{{ 'helpModal.feedback.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'feedback') {
    <sh-text id="help-modal-text-113">
      {{ 'helpModal.feedback.text1' | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'feedback') {
    <sh-text id="help-modal-text-114">
      {{ feedbackText2Key | transloco }}
    </sh-text>
  }
  @if (selectedHelpModule === 'feedback') {
    <sh-button id="help-modal-button-provide-feedback" size="auto" [attr.label]="feedbackButtonKey | transloco" (click)="openURL(feedbackUrl,$event)"></sh-button>
  }
  <!-- Versions -->
  @if (selectedHelpModule === 'versions') {
    <sh-text id="help-modal-text-115" size="title-1">{{ 'helpModal.versions.title' | transloco }}</sh-text>
  }
  @if (selectedHelpModule === 'versions') {
    <ul>
      @for (version of releaseNotes; track version.version) {
        <li>
          <b>Version {{ version.version }}</b>
          {{ version.title }}
          <ul>
            @for (feature of version.features; track feature) {
              <li>{{ feature }}</li>
            }
          </ul>
          <br/>
        </li>
      }
    </ul>
  }
</div>
}